var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.6777 11.5625C21.6812 12.8824 21.3728 14.1844 20.7777 15.3625C20.0722 16.7742 18.9875 17.9617 17.6452 18.7918C16.3029 19.6219 14.756 20.0619 13.1777 20.0625C11.8579 20.0659 10.5558 19.7576 9.37773 19.1625L3.67773 21.0625L5.57773 15.3625C4.98267 14.1844 4.67429 12.8824 4.67773 11.5625C4.67835 9.98426 5.11835 8.43735 5.94845 7.09505C6.77856 5.75275 7.96599 4.66807 9.37773 3.9625C10.5558 3.36743 11.8579 3.05906 13.1777 3.0625H13.6777C15.7621 3.17749 17.7308 4.05726 19.2069 5.53336C20.683 7.00945 21.5627 8.97815 21.6777 11.0625V11.5625Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCircle);
export default __webpack_public_path__ + "static/media/message-circle.b4414ada45b859caaff3bcc05f0e6209.svg";
export { ForwardRef as ReactComponent };